import React from 'react'
import { Typography, useTheme } from '@mui/material'
import { NotificationBellIcon } from 'redesign/components/atoms/Icon'
import TimelineIconText from 'redesign/components/molecules/timeline-icon-text'
import type { TimelineReminderProps } from './types'

const TimelineReminder: React.FC<TimelineReminderProps> = ({ boldText, reminder }) => {
  const { palette } = useTheme()

  if (!reminder) return null

  return (
    <TimelineIconText icon={NotificationBellIcon} color={palette.text.secondary} testId="timeline-reminder">
      <Typography color={palette.text.primary} variant="body2">
        {boldText && <b data-testid="timeline-reminder-bold-text">{boldText}: </b>}
        {reminder}
      </Typography>
    </TimelineIconText>
  )
}

export default TimelineReminder
